import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import OnboardInitiate from "./pages/initiate/OnboardInitiate";
import OnboardOpenBankingInitiate from "./pages/initiate/OnboardOpenBankingInitiate";
import OnboardFinaliseContainer from "./pages/finalise/OnboardFinaliseContainer";
import OnboardSummaryContainer from "./pages/summary/OnboardSummaryContainer";
import {apiContext} from "./ApiContext";
import {api} from "./Dependencies";
import RootView from "./pages/RootView";
import { Buffer } from "buffer/";
import MigrateFinaliseContainer from "./pages/finalise/MigrateFinaliseContainer";
import OpenBankingRedirectErrorContainer from "./pages/open-banking-error/OpenBankingRedirectErrorContainer";
import { ToastProvider } from "@myob/myob-widgets";
import ConsentManagementErrorView from "./pages/consent-management-error/ConsentManagementErrorView";
import ConsentManagementSuccessView from "./pages/consent-management-success/ConsentManagementSuccessView";
import ConsentManagementDashboard from "./pages/initiate/ConsentManagementDashboard";
import ExistingEditContainer from "./pages/finalise/reconsent/ExistingEditContainer";
import { AuthProvider } from "./common/AuthContext";
import AuthGuard from "./common/AuthGuard";
import OpenBankingLoadingPage from "./pages/open-banking-loading/OpenBankingLoadingPage";

window.Buffer = window.Buffer || Buffer;

function App() {
  let query = new URLSearchParams(useLocation().search);

  return (
    <AuthProvider>
      <apiContext.Provider value={ api }>
        <Switch>
        {/*Passcode are built for Exo-ANZ PoC and is currently archiving in the archive folder
        Tests fail after Feelix update and 0Auth flow issue will also need to be solved*/}
        {/*<Route exact path="/onboard">*/}
        {/*  <Passcode code={query.get("code")} redirectUrl={query.get("redirectUrl")}/>*/}
        {/*</Route>*/}
        <Route path="/onboard/initiate">
          <AuthGuard>
            <OnboardInitiate
              portalCode={query.get("code")}
              inputApplicationId={query.get("application_id")}
              redirectUrl={query.get("redirectUrl")}/>
          </AuthGuard>
        </Route>
        <Route path="/onboard/finalise">
          <AuthGuard>
            <OnboardFinaliseContainer
              authCode={query.get("code")}
              consentId={query.get("id")}
              onboardingApplicationData={query.get("state")}
              error={query.get("error")}/>
          </AuthGuard>
        </Route>
        <Route path="/migration/finalise">
          <AuthGuard>
            <ToastProvider>
              <MigrateFinaliseContainer
                authCode={query.get("code")}
                consentId={query.get("id")}
                migrationApplicationData={query.get("state")}
                error={query.get("error")}/>
            </ToastProvider>
          </AuthGuard>
        </Route>
        <Route path="/onboard/openbanking/initiate">
          <AuthGuard>
            <OnboardOpenBankingInitiate
              productRedirectUrl={query.get("redirectUrl")}
              connectedUrl={query.get("connectUrl")}
              state={query.get("state")}
            />
          </AuthGuard>
        </Route>
        <Route path="/onboard/openbanking/connecting">
          <AuthGuard>
            <OpenBankingLoadingPage
              productRedirectUrl={query.get("productRedirectUrl")}
              state={query.get("state")}
            />
          </AuthGuard>
        </Route>
        <Route path="/onboard/summary">
          <OnboardSummaryContainer
            applicationId={query.get("applicationId")}
            consumptionId={query.get("consumptionId")}
            redirectUrl={query.get("redirectUrl")}/>
        </Route>
        <Route path="/existing/edit">
          <AuthGuard>
            <ExistingEditContainer consentId={query.get("consentId")}/>
          </AuthGuard>
        </Route>
        <Route path="/openbanking/error">
          <AuthGuard>
            <OpenBankingRedirectErrorContainer
              mode={query.get("mode")}
              applicationId={query.get("applicationId")}
              errorCode={query.get("error")}
            />
          </AuthGuard>
        </Route>
        <Route path="/consent-management/openbanking/initiate">
          <ConsentManagementDashboard
            connectUrl={query.get("connectUrl")}
            productRedirectUrl={query.get("redirectUrl")}/>
        </Route>
        <Route path="/consent-management/openbanking/error">
          <ConsentManagementErrorView />
        </Route>
        <Route path="/consent-management/openbanking/success">
          <ConsentManagementSuccessView />
        </Route>
        <Route path="/*">
          <RootView/>
        </Route>
        </Switch>
      </apiContext.Provider>
    </AuthProvider>
  );
}

export default App;
